<template>
  <div class="table-pagination d-flex align-center justify-end py-2 px-4">
    <span class="text-body-2 mr-4">Rows per page:</span>
    <select
      class="rows-per-page-select mr-6"
      :value="rowsPerPage"
      @change="$emit('update:rowsPerPage', Number($event.target.value))"
    >
      <option v-for="opt in rowsPerPageOptions" :key="opt" :value="opt">
        {{ opt }}
      </option>
    </select>
    <span class="text-body-2 mr-4">
      {{ rangeStart }}-{{ rangeEnd }} of {{ totalItems }}
    </span>
    <v-btn
      icon
      variant="plain"
      size="small"
      :disabled="page <= 1"
      @click="$emit('update:page', page - 1)"
    >
      <v-icon icon="chevron_left" />
    </v-btn>
    <v-btn
      icon
      variant="plain"
      size="small"
      :disabled="page >= totalPages"
      @click="$emit('update:page', page + 1)"
    >
      <v-icon icon="chevron_right" />
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "TablePagination",

  props: {
    page: { type: Number, required: true },
    rowsPerPage: { type: Number, required: true },
    totalItems: { type: Number, required: true },
    rowsPerPageOptions: {
      type: Array,
      default: () => [10, 25, 50, 100],
    },
  },

  emits: ["update:page", "update:rowsPerPage"],

  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.totalItems / this.rowsPerPage));
    },
    rangeStart() {
      return Math.min((this.page - 1) * this.rowsPerPage + 1, this.totalItems);
    },
    rangeEnd() {
      return Math.min(this.page * this.rowsPerPage, this.totalItems);
    },
  },
};
</script>

<style scoped>
.table-pagination {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
}

.rows-per-page-select {
  border: none;
  background: transparent;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
  cursor: pointer;
  outline: none;
  padding: 4px 24px 4px 8px;
  appearance: none;
  -webkit-appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24'%3E%3Cpath fill='rgba(0,0,0,0.54)' d='M7 10l5 5 5-5z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 4px center;
}
</style>
